import React, { useState } from "react";
import Modal from "../../atoms/Dropdown";
import { useSelector } from "react-redux";
import LoginOption from "../../atoms/LoginOptions";
import SearchBar from "../../atoms/SearchButton";
import NotificationList from '../../atoms/NoticationList'

const Header = ({ isHomePage }) => {
  const { isAuth, userType } = useSelector((state) => state.authReducer);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [searchItem, setSearchItem] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
 
  const handleButtonClick = () => {
    setModalOpen(false);
  };

  const handleSearch = (searchTerm) => {
    // alert(`Searching for: ${searchTerm}`);
  };

  

  const welcomeMessage = isAuth ? "Your Dashboard" : "OffsetGo Marketplace";
  const headerContent = isHomePage ? (
    <>
      Welcome to <span className="font-bold">{welcomeMessage}</span>
    </>
  ) : isAuth ? (
    <SearchBar
      onSearch={handleSearch}
      setSearchItem={setSearchItem}
      variant="rounded"
      textSize="[15px]"
      className="text-black text- center"
      borderColor="border-none"
      placeholderColor="grey"
      inputBackground="grey"
      svgStrokeColor="black"
      inputWidth="96"
      inputHeight="8"
    />
  ) : null;

  return (
    <>
      {headerContent && (
        <div className="flex justify-between">
          <div className="text-xl mt-4 ml-4 font-normal leading-normal">
            {headerContent}
          </div>
          <div className="flex flex-row">
            <div className="text-2xl font-medium text-center mt-4">
              {isAuth && <LoginOption userType={userType}  openNotifications={openNotifications} setOpenNotifications={setOpenNotifications} />}
            </div>
            {isAuth && (
              <div className="mr-4">
                <Modal onCancel={handleButtonClick} />
              </div>
            )}
          </div>
        </div>
      )}
      {
       openNotifications && <div className="mx-10"> <NotificationList onClose={() => setOpenNotifications(false)} /></div>}
    </>
  );
};

export default Header;
